const general = {
  sites: 'Sitios',
  site: 'Sitio',
  add_site: 'Nuevo Sitio',
  edit_site_access: 'Editar Acceso Sitio',
  search_site: 'Sitio de búsqueda',
  delete_site_message: '¿Estás segura de que quieres eliminar {{site}}?',
  notifications: 'Notificaciones',
  notification: 'Notificación',
  events: 'Eventos',
  site_info: 'Información del sitio',
  add_notification: 'Nueva Notificación',
  send_to: 'Enviar a',
  delete_contact_message:
    '¿Estás seguro de que quieres eliminar el contacto {{contact}}?',
  invalid_email: 'Formato de correo electrónico inválido',
  active_web_access: 'Acceso web activo',
  no_web_access: 'Sin acceso web',
  select_unselect_all: 'Seleccionar/Deseleccionar Todo',
  notification_at_least_one: 'Selecciona al menos una notificación',
  table: {
    name: 'NOMBRE',
    country: 'PAÍS',
    city: 'CIUDAD',
    state: 'EXPRESAR',
    timezone: 'ZONA HORARIA',
  },
};

export default general;
